function CardioIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.1231 4.68938C21.2096 4.23435 22.3745 4 23.5513 4C24.728 4 25.8929 4.23435 26.9794 4.68938C28.0656 5.14427 29.0518 5.81067 29.882 6.64998C30.7124 7.48905 31.3711 8.48513 31.82 9.5803C32.269 10.6756 32.5 11.8492 32.5 13.0342C32.5 14.2191 32.269 15.3927 31.82 16.488C31.371 17.5832 30.7127 18.579 29.8821 19.4182L19.075 30.3414C18.2062 31.2195 16.7931 31.2195 15.9243 30.3414L5.11707 19.418C3.44018 17.7231 2.5 15.4266 2.5 13.0342C2.5 10.6418 3.44018 8.34521 5.11707 6.6503C6.79432 4.95503 9.07144 4.00066 11.4481 4.00066C13.6952 4.00066 15.8534 4.85384 17.4996 6.37977C18.2685 5.66693 19.1563 5.09429 20.1231 4.68938ZM23.5513 6C22.6402 6 21.7379 6.18141 20.8957 6.53413C20.0536 6.88681 19.2875 7.40423 18.6419 8.057L18.2105 8.493C18.0227 8.68285 17.7667 8.78968 17.4997 8.78968C17.2326 8.78968 16.9766 8.68285 16.7888 8.493L16.3574 8.05694C15.0535 6.73906 13.2874 6.00066 11.4481 6.00066C9.60882 6.00066 7.84268 6.73906 6.53882 8.05694C5.2346 9.37517 4.5 11.1653 4.5 13.0342C4.5 14.903 5.2346 16.6931 6.53882 18.0114L17.3461 28.9348C17.4321 29.0217 17.5672 29.0217 17.6533 28.9348L28.4605 18.0114C29.1063 17.3589 29.6194 16.5834 29.9695 15.7294C30.3196 14.8752 30.5 13.9594 30.5 13.0342C30.5 12.109 30.3196 11.1931 29.9695 10.3389C29.6194 9.48501 29.1062 8.70936 28.4604 8.05684C27.8149 7.40419 27.0489 6.8868 26.2068 6.53413C25.3646 6.18141 24.4623 6 23.5513 6Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5768 9.00297C14.0126 9.03653 14.3761 9.34925 14.4744 9.77516L16.8825 20.2104L18.6221 17.0212C18.7973 16.6999 19.1341 16.5 19.5 16.5H23.5C24.0523 16.5 24.5 16.9477 24.5 17.5C24.5 18.0523 24.0523 18.5 23.5 18.5H20.0936L17.3779 23.4789C17.179 23.8434 16.7756 24.0472 16.3641 23.9907C15.9527 23.9343 15.619 23.6295 15.5256 23.2249L13.2432 13.3345L11.4285 17.8714C11.2766 18.2511 10.9089 18.5 10.5 18.5H1.5C0.947715 18.5 0.5 18.0523 0.5 17.5C0.5 16.9477 0.947715 16.5 1.5 16.5H9.82297L12.5715 9.62863C12.7339 9.22279 13.141 8.96941 13.5768 9.00297Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default CardioIcon;
